import React, { useState } from "react";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Personnel_Details_table() {

  const data = [
    {
      date: "12 Jan 2025",
      name: "Rajesh Kumar",
      designation: "Lab Technician",
      experience: "3 Years",
      qualification: "B.Sc. Chemistry",
      specialization: "Coal Analysis",
      training: "Safety & Handling Training",
      contact: "9876543210",
      email: "rajesh.kumar@example.com",
    },
    {
      date: "03 Jan 2025",
      name: "Priya Sharma",
      designation: "Senior Analyst",
      experience: "7 Years",
      qualification: "M.Sc. Environmental Science",
      specialization: "Coal Analysis",
      training: "Proximate & Ultimate Analysis",
      contact: "9876543210",
      email: "priya.sharma@example.com",
    },
    {
      date: "03 Jan 2025",
      name: "Amit Verma",
      designation: "Quality Manager",
      experience: "10 Years",
      qualification: "M.Tech Chemical Engineering",
      specialization: "Quality Assurance",
      training: "Internal Auditor Training",
      contact: "9988776655",
      email: "neha.patel@example.com",
    },
  ];


   const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Experience</th>
                  <th>Qualification</th>
                  <th>Specialization</th>
                  <th>Relevant Training</th>
                  <th>Contact No.</th>
                  <th>Email</th>
                </tr>
              </thead>

              <tbody>
                {data.map((row, index) => (
                  <tr key={index}>
                    <td>{row.date}</td>
                    <td>{row.name}</td>
                    <td>{row.designation}</td>
                    <td>{row.experience}</td>
                    <td>{row.qualification}</td>
                    <td>{row.specialization}</td>
                    <td>{row.training}</td>
                    <td>{row.contact}</td>
                    <td>{row.email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      </section>
    </>
  );
}

export default Personnel_Details_table;
